import { render, staticRenderFns } from "./ngo-faq.vue?vue&type=template&id=7db1550a&scoped=true&"
import script from "./ngo-faq.vue?vue&type=script&lang=js&"
export * from "./ngo-faq.vue?vue&type=script&lang=js&"
import style0 from "./ngo-faq.vue?vue&type=style&index=0&id=7db1550a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db1550a",
  null
  
)

export default component.exports